import { Skeleton } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import NoData from 'components/elements/Reports/NoData';
import React from 'react';
import { Aggregation } from 'services/hooks/space-service';
import { colours } from 'utils/constants';

export default function TimeSeriesBarGraph(props: {
  x: string[];
  y: number[];
  loading: boolean;
  aggregation: Aggregation;
  noDataHint: string;
  yAxisLabel: string;
}) {
  const { x, y, loading, aggregation, noDataHint, yAxisLabel } = props;
  const GRAPH_HEIGHT = 300;

  if (loading) {
    return <Skeleton variant="rectangular" height={GRAPH_HEIGHT} />;
  }

  if (!x || !y || !x.length || !y.length) {
    return <NoData height={GRAPH_HEIGHT} hint={noDataHint} />;
  }

  let xAxisLabel = '';
  switch (aggregation) {
    case 'yearly':
      xAxisLabel = 'Year';
      break;
    case 'monthly':
      xAxisLabel = 'Month of the year';
      break;
    case 'daily':
      xAxisLabel = 'Day of the week';
      break;
    case 'hourly':
      xAxisLabel = 'Hour of the day';
      break;
    default:
      xAxisLabel = '';
      break;
  }

  return (
    <div style={{ marginLeft: 20 }}>
      <BarChart
        sx={{
          '& .MuiBarElement-series-occupancy': {
            fill: "url('#barGradient')"
          },
          // change all labels fontFamily shown on both xAxis and yAxis
          '& .MuiChartsAxis-tickContainer .MuiChartsAxis-tickLabel': {
            fill: colours.axisGrey
          },
          // bottomAxis Line Styles
          '& .MuiChartsAxis-bottom .MuiChartsAxis-line': {
            stroke: colours.axisGrey,
            strokeWidth: 0.4
          },
          // leftAxis Line Styles
          '& .MuiChartsAxis-left .MuiChartsAxis-line': {
            stroke: colours.axisGrey,
            strokeWidth: 0.4
          },
          // tick colour
          '& .MuiChartsAxis-tick': {
            stroke: colours.axisGrey,
            strokeWidth: 0.4
          },
          // axis label colour
          '& .MuiChartsAxis-root .MuiChartsAxis-label': {
            fill: colours.axisGrey
          },
          // axis label positioning
          '& .MuiChartsAxis-left .MuiChartsAxis-label': {
            transform: 'translate(-11px, 0)'
          }
        }}
        xAxis={[
          {
            scaleType: 'band',
            data: x,
            label: xAxisLabel
          }
        ]}
        yAxis={[
          {
            id: 'value',
            valueFormatter: (value) => `${value.toLocaleString()}`,
            label: yAxisLabel
          }
        ]}
        series={[
          {
            id: 'occupancy',
            data: y,
            color: colours.darkTeal,
            valueFormatter: (value) => `${value.toLocaleString()}`
          }
        ]}
        axisHighlight={{ x: 'none' }}
        height={GRAPH_HEIGHT}
      >
        <defs>
          <linearGradient id="barGradient" gradientTransform="rotate(90)">
            <stop offset="1%" stopColor={colours.darkTeal} />
            <stop offset="99%" stopColor={colours.lightTeal} />
          </linearGradient>
        </defs>
      </BarChart>
    </div>
  );
}
